import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ButtonGroup from "./components/buttonGroup/ButtonGroup";
import Content1 from "./pages/servicioTerceros";
import Content2 from "./pages/logistica";
import Content3 from "./pages/energia";
import Content4 from "./pages/mineria";
import Content5 from "./pages/materiasPrimas";
import Content6 from "./pages/equiposConsumibles";

const App = () => (
  <div style={{ width: "100vw" }}>
    <div id="page">

      <Router>
        <Header />

        <div className="app-content">
          <div style={{ position: "relative" }}>
            <ButtonGroup />
          </div>

          <main>
            <Routes>
              <Route path="/servicio-terceros" element={<Content1 />} />
              <Route path="/logistica" element={<Content2 />} />
              <Route path="/energia" element={<Content3 />} />
              <Route path="/mineria" element={<Content4 />} />
              <Route path="/materias-primas" element={<Content5 />} />
              <Route path="/equipos-consumibles" element={<Content6 />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </div>

  </div>
);

/*

*/

export default App;
